"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ServiceType = _interopRequireDefault(require("./ServiceType"));

var _ServiceBase2 = _interopRequireDefault(require("./ServiceBase"));

/**
 *
 */
var PublicService =
/*#__PURE__*/
function (_ServiceBase) {
  (0, _inherits2["default"])(PublicService, _ServiceBase);

  /**
   * @param {string} name
   * @param {string[]} dependencies
   */
  function PublicService(name) {
    var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    (0, _classCallCheck2["default"])(this, PublicService);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PublicService).call(this, _ServiceType["default"].PUBLIC, name, dependencies));
  }

  return PublicService;
}(_ServiceBase2["default"]);

var _default = PublicService;
exports["default"] = _default;